import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const RESEND_ENTERPRISE_INVITE = 'RESEND_ENTERPRISE_INVITE';
export const RESEND_ENTERPRISE_INVITE_SUCCESS =
  'RESEND_ENTERPRISE_INVITE_SUCCESS';
export const RESEND_ENTERPRISE_INVITE_FAILURE =
  'RESEND_ENTERPRISE_INVITE_FAILURE';

// Action Creators
export const resendEnterpriseInvite = () => ({
  type: RESEND_ENTERPRISE_INVITE,
});

export const resendEnterpriseInviteSuccess = (data) => ({
  type: RESEND_ENTERPRISE_INVITE_SUCCESS,
  payload: data,
});

export const resendEnterpriseInviteFailure = (error) => ({
  type: RESEND_ENTERPRISE_INVITE_FAILURE,
  payload: error,
});

// Thunk Function
export const resendEnterpriseInviteCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(resendEnterpriseInvite());
    try {
      const response = await postMethodWithToken(
        url.staff + data?.id + '/send-admin-invite/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(resendEnterpriseInviteSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(resendEnterpriseInviteFailure(response?.data));
      }
    } catch (error) {
      dispatch(resendEnterpriseInviteFailure(error?.message));
    }
  };
};
